import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ONBOARDING_V2_ENABLED } from '../../config/featureFlags';
import { shouldShowOnboarding } from '../../utils/onboardingEligibility';
import { useAuth } from '../../contexts/AuthContext';
import { usePreferences } from '../../contexts/PreferencesContext';
import './CoursesColumn.css';

export default function MyCoursesEmptyState({ onAddCourse }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { preferences: uiPreferences } = usePreferences();

  const handleAdd = () => {
    if (typeof onAddCourse === 'function') return onAddCourse();
    // If onboarding V2 is active and user hasn't completed it, go to onboarding
    try {
      if (ONBOARDING_V2_ENABLED && shouldShowOnboarding({ user, uiPreferences: uiPreferences || {} })) {
        navigate('/onboarding');
      } else {
        navigate('/create-course-wizard');
      }
    } catch (e) { /* ignore */ }
  };

  // Debug: announce mounting so we can verify DOM presence during runtime
  React.useEffect(() => {
    try {
      console.log('[MyCoursesEmptyState] mounted');
      const skelCount = document.querySelectorAll('.scoutiq-course-card.is-skeleton').length;
      console.log('[MyCoursesEmptyState] skeletonCount=', skelCount);
    } catch (e) { /* ignore */ }
  }, []);
  return (
    <div className="courses-empty-state" role="region" aria-label="No courses">
      <div className="courses-empty-illustration">
        <div className="courses-empty-spotlight" />
        <img src="/scout_images/scout_wave_new.png" alt="Scout waving" style={{ width: 110, height: 'auto' }} />
      </div>
      <div className="courses-empty-copy">
        <h2 className="courses-empty-title">Build your semester command center</h2>
        <p className="courses-empty-body">
          Add your first course to unlock timelines, assignment tracking, study planning, notes, documents, and course-specific AI tools.
        </p>
      </div>
      <button type="button" className="courses-empty-cta" onClick={handleAdd} aria-label="Add your first course">
        + Add Your First Course
      </button>
      <p className="courses-empty-helper">
        Your dashboard will automatically start filling in as courses are added.
      </p>
    </div>
  );
}
